import React, { useState, useEffect } from "react";
import { Container, Form } from "react-bootstrap";
import Select from "react-select";
import Switch from "react-switch";
import ElementLoader from "../Loader/ElementLoader";
import GatewayUrl from "../Gateway/Gateway";
import ResponseModal from "./Elements/ResponseModal";
import { RootState } from '../../store/store'
import { useDispatch, useSelector } from 'react-redux'
import { handleLoadingError } from '../../store/features/session'
import SelectCustomStyles from "../SelectCustomStyles/SelectCustomStyles";
import { IReasons, ITimes } from '../../interface/absences'
import WrongFileSizeModal from './Elements/WrongFileSizeModal'
import { absenceReasonCategories, ReasonIsOtherAbsenceId, ReasonIsSickNoteId } from '../../constants/absenceReasonCategories'

import "./Style/CreateAbsenceEntry.css";

const ReasonForWholeDay: any = ["bf05f280-3ba4-4246-921d-2a9914a38fbb", "e5523cc3-3099-4bea-a5ab-952b20a0fe02"];
const ReasonIsCompensationOfExtraHoursId: string = "c317c1d9-e2b0-460e-a4d2-a33f95750d0f";
const ReasonToBlockDateRange: any = ["c317c1d9-e2b0-460e-a4d2-a33f95750d0f", ReasonIsSickNoteId];

let uploadFileId: number = 0;

const CreateAbsenceEntry = (): JSX.Element => {
  const dispatch = useDispatch()

  const ServerDate: string = useSelector((state: RootState) => state.serverDate.serverDate)
  const uuidOffer: string = useSelector((state: RootState) => state.participant.uuidOffer)
  const AbsenceReasons: Array<IReasons> = useSelector((state: RootState) => state.absenceReasons.reasons)
  const AbsenceTimes: Array<ITimes> = useSelector((state: RootState) => state.absenceReasons.times)
  const token: string = useSelector((state: RootState) => state.participant.token)

  const [IsLoading, setIsLoading] = useState(false);
  const [DocumentName, setDocumentName] = useState("");
  const [DocumentTrigger, setDocumentTrigger] = useState(false);
  const [DocumentUpload, setDocumentUpload]: any = useState(null);
  const [WrongUploadFormat, setWrongUploadFormat] = useState(false);
  const [SelectedFrom, setSelectedFrom] = useState({ label: "Anfang", value: "" });
  const [SelectedEnd, setSelectedEnd] = useState({ label: "Ende", value: "" });
  const [AbsentReason, setAbsentReason] = useState({ label: "Grund der Abwesenheit", value: "" });
  const [AbsentReasonText, setAbsentReasonText] = useState("");
  const [SelectedFromDay, setSelectedFromDay] = useState(ServerDate);
  const [SelectedTillDay, setSelectedTillDay] = useState(ServerDate);
  const [FromEqualTillDate, setFromEqualTillDate] = useState(false);
  const [ShowModal, setShowModal] = useState(false);
  const [ForceWholeDay, setForceWholeDay] = useState(false);
  const [WholeDaySwitch, setWholeDaySwitch] = useState(false);
  const [ModalContent, setModalContent] = useState("");
  const [ReasonIsCompensationOfExtraHours, setReasonIsCompensationOfExtraHours] = useState(false);
  const [BlockDateRange, setBlockDateRange] = useState(false);
  const [WrongFilesizeAlert, setWrongFilesizeAlert] = useState(false)

  // user has selected a file for upload
  const selectFileForUpload = (event: any): void => {
    setDocumentName(event.target.files[0] ? event.target.files[0].name : "");
    setDocumentTrigger(event.target.files[0] ? true : false);
    setDocumentUpload(event.target.files[0] ? event.target.files[0] : null);
  };

  // user has removed the file for upload
  const removeFileFromUpload = (): void => {
    setDocumentName("");
    setDocumentTrigger(false);
    setDocumentUpload(null);
  };

  // user has selected a from time
  const selectFromOnChange = (e: any): void => setSelectedFrom(e);

  // user has selected a till time
  const selectEndOnChange = (e: any): void => setSelectedEnd(e);

  // user has selected an absence reason
  const absentReasonChanged = (e: any): void => {
    setBlockDateRange(ReasonToBlockDateRange.includes(e.value) ? true : false);
    setAbsentReason(e);
    setAbsentReasonText("");

    // selected absence reason is only whole day
    if (ReasonForWholeDay.includes(e.value)) {
      setSelectedFrom({ label: "Anfang", value: "" });
      setSelectedEnd({ label: "Ende", value: "" });
      setForceWholeDay(true);
      setWholeDaySwitch(true);
    } else {
      // selected absence reason has no time values
      if (ReasonToBlockDateRange.includes(e.value)) {
        setSelectedTillDay(SelectedFromDay);
        setFromEqualTillDate(false);
      }

      // selected absence reason is compensation of extra hours
      if (e.value === ReasonIsCompensationOfExtraHoursId) {
        setReasonIsCompensationOfExtraHours(true);
        setDocumentName("");
        setDocumentTrigger(false);
        setDocumentUpload(null);
      } else {
        setReasonIsCompensationOfExtraHours(false);
      }

      setForceWholeDay(false);
      setWholeDaySwitch(false);
    }
  };

  // user has enterd a text
  const textareaOnChange = (e: any): void => {
    if (e.target.value.length <= 30) {
      setAbsentReasonText(e.target.value);
    }
  };

  // user has selected a category for the reason "Sonstige Fehlzeit"
  const reasonCategoryOnChange = (e: any): void => setAbsentReasonText(e.value);

  // creates the database entry
  const createAbsenceTime = (): void => {
    fetch(GatewayUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        method: "createNewAbsenceTime",
        selectDateFrom: String(SelectedFromDay),
        selectDateTo: String(SelectedTillDay),
        beginn: String(SelectedFrom.value),
        end: String(SelectedEnd.value),
        reasonForAbsence_id: AbsentReason.value,
        reasonComment: String(AbsentReasonText),
        sessionId: token,
        createdAbsenceId: uploadFileId,
        offerId: uuidOffer,
        WholeDay: WholeDaySwitch ? "0" : "1",
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        // response has no values
        if (Object.keys(result).length === 0) {
          dispatch(handleLoadingError("lzk#990040"));
        } else if (result.error) {
          // response has an error flag
          setModalContent(result.message);
          setShowModal(true);
          setIsLoading(false);
        } else if (result.creationStatus) {
          // response is ok
          setDocumentName("");
          setDocumentTrigger(false);
          setDocumentUpload(null);
          setSelectedFrom({ label: "Anfang", value: "" });
          setSelectedEnd({ label: "Ende", value: "" });
          setAbsentReason({ label: "Grund der Abwesenheit", value: "" });
          setAbsentReasonText("");
          setModalContent("Ihre Abwesenheit wurde erfolgreich erfasst!");
          setShowModal(true);
        }
      })
      .catch(() => dispatch(handleLoadingError("lzk#990017")));

    uploadFileId = 0;
  };

  // user has clicked the creation button
  const submitForm = () => {
    setIsLoading(true);

    // checks if there is an upload
    // if true, upload thedocument and create an database entry for it. If this is done, create the absence time
    if (DocumentUpload !== null) {
      const data = new FormData();
      data.append("file", DocumentUpload);
      data.append("method", "uploadFiles");

      fetch(GatewayUrl, {
        method: "POST",
        body: data,
      })
        .then((response) => response.json())
        .then((result) => {
          result = JSON.parse(result);
          if (Object.keys(result).length === 0) {
            dispatch(handleLoadingError("lzk#990041"));
          } else if (result.error === 'wrong format') {
            setWrongUploadFormat(true);
            setIsLoading(false);
          } else if (result.error === 'wrong filesize') {
            setWrongFilesizeAlert(true)
            setIsLoading(false);
          } else {
            var createdAbsenceIdTemp: any = result;
            uploadFileId = createdAbsenceIdTemp.createdAbsenceId;
            setWrongUploadFormat(false);
            createAbsenceTime();
          }
        })
        .catch(() => setIsLoading(false));
    } else {
      // no upload
      createAbsenceTime();
    }
  };

  // user has changed the from date
  const changeSelectDateFrom = (event: any) => {
    const isSameDay: boolean = event.target.value === SelectedTillDay || ReasonToBlockDateRange.includes(AbsentReason.value) ? false : true;

    setSelectedFromDay(event.target.value);
    setFromEqualTillDate(isSameDay);

    if (!ReasonToBlockDateRange.includes(AbsentReason.value)) {
      if (!isSameDay) {
        setSelectedFrom({ label: "Anfang", value: "" });
        setSelectedEnd({ label: "Ende", value: "" });
      }
    } else {
      changeSelectDateTo(event);
    }
  };

  // user has changed the till date
  const changeSelectDateTo = (event: any) => {
    const isSameDay = SelectedFromDay === event.target.value || ReasonToBlockDateRange.includes(AbsentReason.value) ? false : true;

    setSelectedTillDay(event.target.value);
    setFromEqualTillDate(isSameDay);

    if (!ReasonToBlockDateRange.includes(AbsentReason.value)) {
      if (!isSameDay) {
        setSelectedFrom({ label: "Anfang", value: "" });
        setSelectedEnd({ label: "Ende", value: "" });
      }
    }
  };

  const HandleSetModalShow = (bool: boolean) => {
    setShowModal(bool);
    setIsLoading(false);
  };

  // validated the from date
  const HandleCheckSelectDateFrom = () => {
    return SelectedFromDay.length === 0 ? true : false;
  };

  // validated the till date
  const HandleCheckSelectDateTo = () => {
    return SelectedTillDay.length === 0 ? true : false;
  };

  // validated the from time
  const HandleCheckSelectTimeBegin = () => {
    return WholeDaySwitch || ForceWholeDay || FromEqualTillDate ? false : SelectedFrom.value.length === 0 ? true : false;
  };

  // validated the till time
  const HandleCheckSelectTimeEnd = () => {
    return WholeDaySwitch || ForceWholeDay || FromEqualTillDate ? false : SelectedEnd.value.length === 0 ? true : false;
  };

  // checks if the from time is higher then the till time
  const HandleCheckIfSelectTimeBeginIsLowerThenSelectTimeEnd = () => {
    var FromTimeMilliSeconds: any = SelectedFrom.value.split(":");
    FromTimeMilliSeconds = FromTimeMilliSeconds[0] * 3600 * 1000 + FromTimeMilliSeconds[1] * 60 * 1000;

    var TillTimeMilliSeconds: any = SelectedEnd.value.split(":");
    TillTimeMilliSeconds = TillTimeMilliSeconds[0] * 3600 * 1000 + TillTimeMilliSeconds[1] * 60 * 1000;

    return SelectedFrom.value.length > 0 && SelectedEnd.value.length > 0 && FromTimeMilliSeconds >= TillTimeMilliSeconds ? true : false;
  };

  // checks if the from date is higher then the till date
  const HandleCheckIfSelectDateBeginIsLowerThenSelectDateEnd = () => {
    return SelectedFromDay.length > 0 && SelectedTillDay.length > 0 && SelectedFromDay > SelectedTillDay ? true : false;
  };

  // validated the absent reason value
  const HandleCheckSelectAbsentReason = () => {
    return AbsentReason.value === "" ? true : false;
  };

  // checkes if the reason needs an additional explanation and if its true, checks if that explanation has a value
  const HandleCheckIsReasonOtherAndHasValue = (): boolean => {
    return (AbsentReason.value === ReasonIsOtherAbsenceId || AbsentReason.value === ReasonIsSickNoteId) &&
      AbsentReasonText.length === 0
      ? true
      : false;
  };

  // function to validating the form
  const ValidatingFormular = () => {
    return !HandleCheckSelectDateFrom() &&
      !HandleCheckSelectDateTo() &&
      !HandleCheckSelectTimeBegin() &&
      !HandleCheckSelectTimeEnd() &&
      !HandleCheckIfSelectTimeBeginIsLowerThenSelectTimeEnd() &&
      !HandleCheckSelectAbsentReason() &&
      !HandleCheckIfSelectDateBeginIsLowerThenSelectDateEnd() &&
      !HandleCheckIsReasonOtherAndHasValue()
      ? true
      : false;
  };

  // function to handle the whole day progress
  const handleChangeWholeDaySwitch = () => {
    setWholeDaySwitch(WholeDaySwitch ? false : true);
    setSelectedFrom({ label: "Anfang", value: "" });
    setSelectedEnd({ label: "Ende", value: "" });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!SelectedFromDay && !SelectedTillDay) {
    return <ElementLoader></ElementLoader>;
  } else {
    const formIsValid = ValidatingFormular();

    return (
      <div className="container-wbs fixing-select-index-issue">
        <form>
          <Container>
            <div className="headline-container">
              <h3 className="text-center my-auto h-100"><i className="my-auto h-100 headline-icon fal fa-poll-h"></i> Sie können nicht am Unterricht teilnehmen?</h3>
            </div>

            <hr></hr>

            <div className="absence-description">
              <p>Bitte teilen Sie uns den Grund Ihrer Abwesenheit mit und laden Sie gegebenfalls einen Nachweis hoch.</p>

              <p>
                Weitere Informationen zu den Fehlzeitenregelungen finden Sie hier:{" "}
                <ul>

                  <li>
                    <a
                      className="link-primary-wbs"
                      href="https://ecampus.wbstraining.de/ilias.php?ref_id=1657350&cmdClass=ilrepositorygui&cmdNode=x6&baseClass=ilRepositoryGUI"
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                    >
                      FAQ
                    </a>
                  </li>
                  <li>
                    <a
                      className="link-primary-wbs"
                      href="https://ecampus.wbstraining.de/ilias.php?ref_id=3933907&cmdClass=ilrepositorygui&cmdNode=x6&baseClass=ilRepositoryGUI"
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                    >
                      Infobox
                    </a>
                  </li>
                </ul>
              </p>
            </div>

            {WrongUploadFormat ? (
              <div className="alert alert-danger alert-danger-wbs" role="alert">
                <h4 className="alert-heading">Falsches Format!</h4>
                <p>Bitte beachten Sie das nur Bild- und PDF Dateien zugelassen sind.</p>
                <hr />
                <small>
                  Erlaubte Formate für den Upload sind: jpeg, jp2, jpc, j2c, j2k, jpx, jpg, png, pdf
                </small>
              </div>
            ) : null}

            <div className="row">
              <div className="col-md-12 mt-4">
                <label>Grund der Abwesenheit</label>
                <p><b>Achtung NEU! - bei Krankmeldungen wird zwischen AU (Papierform) und eAU (Elektronische Krankmeldung) unterschieden</b></p>
                <Select
                  className="wbs-select"
                  isSearchable={true}
                  placeholder="Grund der Abwesenheit"
                  closeMenuOnSelect={true}
                  options={AbsenceReasons}
                  onChange={absentReasonChanged}
                  value={AbsentReason}
                  styles={SelectCustomStyles}
                  isLoading={AbsenceReasons === null ? true : false}
                  isDisabled={AbsenceReasons === null ? true : false}
                />
              </div>
            </div>

            {AbsentReason && AbsentReason.value === ReasonIsOtherAbsenceId ? (
              <div className="row">
                <div className="col-md-12 mt-4">
                  <label>Bitte wählen Sie den Grund der Abwesenheit.</label>
                  <Select
                    className="wbs-select"
                    isSearchable={false}
                    placeholder="Bitte auswählen"
                    closeMenuOnSelect={true}
                    options={absenceReasonCategories}
                    onChange={reasonCategoryOnChange}
                    value={AbsentReasonText === "" ? null : { label: AbsentReasonText, value: AbsentReasonText }}
                    styles={SelectCustomStyles}
                  />
                </div>
              </div>
            ) : null}

            {AbsentReason && AbsentReason.value === ReasonIsSickNoteId ? (
              <div>
                <div className="row">
                  <div className="col-8 mt-4">
                    <label>Bitte beschreiben Sie den Grund der Abwesenheit.</label>
                  </div>
                  <div className="col-4 mt-4">
                    <label className="text-right w-100">{AbsentReasonText.length} / 30 Zeichen</label>
                  </div>
                </div>

                <textarea
                  placeholder="Bitte beschreiben Sie den Grund der Abwesenheit."
                  className="form-control lzk-capture-time-textarea"
                  rows={3}
                  value={AbsentReasonText}
                  onChange={textareaOnChange}
                  maxLength={30}
                ></textarea>
              </div>
            ) : null}

            <div className="row">
              <div className="col-lg col-md-2 mt-4" style={{ maxWidth: "100px" }}>
                <label>Ganztägig</label>
                <p className="my-auto">
                  <Switch
                    className="react-switch"
                    onChange={handleChangeWholeDaySwitch}
                    checked={WholeDaySwitch}
                    onColor="#fa7268"
                    offColor="#01254b"
                    handleDiameter={30}
                    height={37}
                    width={80}
                    disabled={ForceWholeDay || ReasonIsCompensationOfExtraHours}
                  />
                </p>
              </div>

              <div className="col-lg col-md mt-4">
                <label>Von</label>
                <input type="date" className="form-control" onChange={(event) => changeSelectDateFrom(event)} value={SelectedFromDay} />
              </div>

              <div className="col-lg col-md-5 mt-4">
                <label>Bis</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(event) => changeSelectDateTo(event)}
                  value={SelectedTillDay}
                  disabled={ReasonIsCompensationOfExtraHours || BlockDateRange}
                />
              </div>

              <div className="col-lg col-md-6 mt-4">
                <label>Anfang</label>
                <Select
                  className="wbs-select"
                  isSearchable={true}
                  isDisabled={WholeDaySwitch || ForceWholeDay || FromEqualTillDate || AbsenceTimes === null ? true : false}
                  isLoading={AbsenceTimes === null ? true : false}
                  placeholder="Beginn"
                  options={AbsenceTimes}
                  onChange={selectFromOnChange}
                  value={SelectedFrom}
                  styles={SelectCustomStyles}
                />

                {ForceWholeDay || FromEqualTillDate ? <small>(Nicht nötig)</small> : null}
              </div>

              <div className="col-lg col-md-6 mt-4">
                <label>Ende</label>
                <Select
                  className="wbs-select"
                  isSearchable={true}
                  isDisabled={WholeDaySwitch || ForceWholeDay || FromEqualTillDate || AbsenceTimes === null ? true : false}
                  placeholder="Ende"
                  options={AbsenceTimes}
                  onChange={selectEndOnChange}
                  value={SelectedEnd}
                  styles={SelectCustomStyles}
                />

                {ForceWholeDay || FromEqualTillDate ? <small>(Nicht nötig)</small> : null}
              </div>
            </div>

            <div className="row">

              <div className="col-md-12 mt-4">
                <p>
                  <b>
                  Bitte beachten Sie. Laden Sie nur die Arbeitgeberversion der Arbeitsunfähigkeitsbescheinigung hoch. Falls Sie nur eine Arbeitsunfähigkeitsbescheinigung mit Diagnose haben, machen Sie diese bitte Unkenntlich, bevor Sie diese hochladen.
                  </b>
                </p>
              </div>

              <div className="col-md-6 mt-1">
                <label>Abwesenheitsnachweis</label>

                <Form.File
                  onChange={(event: any) => selectFileForUpload(event)}
                  className="custom-upload"
                  id="custom-file"
                  name="upload-absence-file"
                  label="zum auswählen hier klicken"
                  data-browse="Hochladen"
                  custom
                  accept="image/*, .pdf"
                  disabled={ReasonIsCompensationOfExtraHours}
                />
                <div className="absence-description">
                  <small>Erlaubte Formate für den Upload sind: jpeg, jp2, jpc, j2c, j2k, jpx, jpg, png, pdf</small>
                  <br></br>
                  <small>Maximale Dateigröße: 4MB</small>
                </div>
              </div>

              {DocumentTrigger ? (
                <div className="col-md-6 mt-4">
                  <label>Ihr ausgewähltes Dokument:</label>

                  <div className="form-row">
                    <div className="col-10">
                      <input className="form-control" type="text" placeholder="" value={DocumentName} aria-label="" readOnly />
                    </div>
                    <div className="col-2">
                      <div className="btn btn-secondary btn-block" onClick={removeFileFromUpload}>
                        <i className="fal fa-trash-alt"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>

            <div className="row">
              <div className="col-md-12 mt-4">
                {formIsValid ? (
                  IsLoading ? (
                    <div className="text-center">
                      <button className="btn btn-primary py-3 px-5 m-1" type="button" disabled>
                        <span className="spinner-border spinner-border-sm mr-3" role="status" aria-hidden="true"></span>
                        bitte warten...
                      </button>
                    </div>
                  ) : (
                    <div className="text-center">
                      <div className="text-center">
                        <div className="btn btn-primary py-3 px-5 m-1" onClick={submitForm}>
                          Abwesenheit erfassen.
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className="text-center">
                    <div className="text-center">
                      <div className="btn btn-primary py-3 px-5 m-1 disabled">Bitte erst alle Felder füllen.</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </form>

        <WrongFileSizeModal show={WrongFilesizeAlert} onHide={() => setWrongFilesizeAlert(false)} />
        <ResponseModal show={ShowModal} ModalContent={ModalContent} onHide={() => HandleSetModalShow(false)} />
      </div >
    );
  }
};

export default CreateAbsenceEntry;
